export default __webpack_public_path__ + "static/media/property_288.27527dde.png";